import { getJuniorSales } from '@/api/user'
import $store from '@/store'
import checkPermission from '@/utils/permission'
import DateUtils from '@/utils/dateUtils'
import { MessageBox } from 'element-ui'
import lang from '@/lang'

export class SalesUtil {
  // 实例集合
  static instance
  static SALES_LOADED = 'sales_loaded'
  constructor() {
    this.isSalesLoaded = false
    this.sales = null
    this.juniorSaleMap = {}
    this.juniorSales = [$store.getters.userId]
  }

  static async getInstance() {
    if (!this.instance) {
      this.instance = new SalesUtil()
      await getJuniorSales($store.getters.userId).then(res => {
        this.sales = res.data
        this.juniorSaleMap = {}
        this.juniorSales = []
        if (this.sales && this.sales.length > 0) {
          for (const user of this.sales) {
            this.juniorSaleMap[user.userId] = true
            this.juniorSales.push(user.userId)
          }
        }
        this.isSalesLoaded = true
      }).catch(() => {
        this.juniorSaleMap[$store.getters.userId] = true
        this.juniorSales = [$store.getters.userId]
      })
    }
    return this.instance
  }

  /**
   * 销售能否看见订舱代理
   * @param configIsOpen 配置是否开启
   * @returns
   */
  static salesCanBookingAgent(configIsOpen) {
    const hide = !configIsOpen && !$store.getters.isAdmin && checkPermission(['role_sales', 'role_salesOfGoods']) &&
      !checkPermission([
        'role_csr', 'role_doc', 'role_sealine', 'role_airline', 'role_overseaOp', 'role_siteOp', 'role_userDefinedRole1', 'role_userDefinedRole2'
      ])
    return !hide
  }

  /**
   * 校验CRM到期日
   * @param $route
   * @param $router
   */
  static checkCrmExpire($route, $router) {
    const crmInvalidDate = $store.state.settings.bsLimitInfo.crmInvalidDate
    if (crmInvalidDate && crmInvalidDate < DateUtils.formatStandardDate(new Date())) {
      MessageBox.confirm(lang.t('Sales.CRMExpiredTip'), lang.t('SystemMaintenance.Prompt'), {
        confirmButtonText: lang.t('common.btn.ok'),
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false,
        showClose: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        $store.dispatch('tagsView/delView', $route).then(({ visitedViews }) => {
          this.toLastView(visitedViews, $router)
        })
      }).catch(() => {})
    }
  }

  /**
   * 移到最后一个view
   * @param visitedViews
   * @param $router
   */
  static toLastView(visitedViews, $router) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView) {
      $router.push(latestView)
    } else {
      $router.push('/')
    }
  }
}
